import { IApiSessionTeam } from 'interfaces/session/ISession';
import moment from 'moment';
import React from 'react';
import { Circle, TaggingInfo, TeamsWrapper, Versus, Wrapper } from './styles/TeamsStyles';

interface IProps {
  awayTeam: IApiSessionTeam;
  homeTeam: IApiSessionTeam;
  gameReference: string;
  fieldName: string;
  localStartTime: any;
}

const Teams: React.FC<IProps> = (props) => {
  const { awayTeam, homeTeam, gameReference, fieldName, localStartTime } = props;
  // TODO: replace moment with dayjs (currently unavailable due no parseZone native function in dayjs - need plugin)
  const time = moment.parseZone(localStartTime);

  return (
    <TeamsWrapper>
      <Wrapper>
        {!awayTeam && !homeTeam ? (
          'No teams provided'
        ) : (
          <>
            {awayTeam && (
              <>
                <Circle backgroundColor='#007AFF' />
                {awayTeam.name} ({awayTeam.shortName}){homeTeam && <Versus> vs </Versus>}
              </>
            )}
            {homeTeam && (
              <>
                <Circle backgroundColor='#DC02B9' />
                {homeTeam.name} ({homeTeam.shortName})
              </>
            )}
          </>
        )}
      </Wrapper>
      <TaggingInfo>
        {time.format('MM/DD/YYYY')}, {time.format('hh:mma')} @ {fieldName} (Game Ref. {gameReference})
      </TaggingInfo>
    </TeamsWrapper>
  );
};

export default Teams;
